import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import shape1 from '../assets/Images/shapes/lefttestimonialThread-01.png';
import shape2 from '../assets/Images/shapes/RightTestimonialThread-01.png';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
const testimonials = [
  {
    id: 1,
    name: 'Sandeep',
    role: 'Patient since 2020',
    quote: 'Best treatment from expert doctors',
    description:
      'Dr.Amrish Reddy general surgeon and Dr.Karthik urology sir best treatment thanks for treatment.',
  },
  {
    id: 2,
    name: 'Amarnath B',
    role: 'Patient since 2021',
    quote: 'Professional and compassionate care',
    description:
      ' I got effected with bells palsy and consulted Rajeswari mam and mam said clear information about disease. And said we have medication here and suggested me to srinivas reddy sir and Bhargavi Mam. Bhargavi Mam Physiotherapist is Superb. I was quite anxious starting physio, but she made me feel comfortable and her treatment helped me significantly. And Srinivas reddy sir gave me confidence about curing of my disease. From then I’m living very peacefully and happily because of them. Thank you Dr.Rajeswari mam, Dr.Srinivas Reddy Sir and Dr.Bhargavi Mam.. ',

  },
  {
    id: 3,
    name: 'Ravi',
    role: 'Patient since 2019',
    quote: 'Highly recommended for gynecology care',
    description:
      ' Dr. Sindhu Kodali gynecology madam has given very nice treatment to my wife.. She is very polite and has very patience.. She listens and understands the patient problems.. I strongly recommended this doctor.. ',
    
  },
  {
    id: 4,
    name: 'Nayak',
    role: 'Patient since 2019',
    quote: 'Confidence-building care and great service',
    description:
      'Dr Amrish Ram Reddy sir general surgeon, I have went form Surgery it was a great experience to me thanks doctor to giving me confidence your words make me strong thanks you so much doctor 🙏 and room service and hospitality very good I really like this hospital thank you MagnAid hospital',
  
  }
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  const nextSlide = () => setIndex((index + 1) % testimonials.length);
  const prevSlide = () =>
    setIndex((index - 1 + testimonials.length) % testimonials.length);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1024); // Up to 1023px (mobile + tablet)
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div>
      <div className='overflow-hidden'>
        <div className='max-w-[1340px] mx-auto px-[24px] md:px-[24px] xl:px-[0px]'>
          <div className='relative'>
            <div 
              className='py-[140px] px-[12px] md:px-[80px] rounded-[24px] bg-[#c4e5e5]'
              style={
                !isMobileOrTablet
                  ? {
                      backgroundImage: `
                        url(${shape1}),
                        url(${shape2})
                      `,
                      backgroundPosition: "100% 100%, 0 56px",
                      backgroundRepeat: "no-repeat, no-repeat",
                      backgroundSize: "auto, auto",
                    }
                  : {}
              }
            >
              <div>
                <div className='flex justify-center' data-aos="fade-up">
                  <h2 className=' text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[48px] text-center md:max-w-[526px]'>
                    Hear from our Happy Patients - genuine experiences
                  </h2>
                </div>
                <div className='flex justify-center' data-aos="fade-up" data-aos-delay="300">
                  <p className='text-[20px] font-[500] text-paraGreen leading-[1.667em] font-body mb-[40px] text-center max-w-[526px]'>
                    Listen from our happy and satisfied patients sharing their genuine experiences.
                  </p>
                </div>
              </div>
              
              <div className='relative flex flex-col items-center justify-center'>
                {/* Carousel Content */}
                <div className='w-full max-w-2xl bg-white rounded-3xl shadow-lg p-10 text-center'>
                  <AnimatePresence mode='wait'>
                    <motion.div
                      key={testimonials[index].id}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.6 }}
                    >
                      <h3 className='text-[24px] md:text-[34px] text-thickGreen mb-4 font-heading'>
                        “{testimonials[index].quote}”
                      </h3>
                      <p className='text-paraGreen mb-6 font-body text-[15px] md:text-[20px]'>
                        {testimonials[index].description}
                      </p>

                      {/* Profile Section */}
                      <div className='flex items-center justify-center gap-4'>
                        <AccountCircleIcon sx={{
                          width:"50px" , height:"50px" ,
                        }} className=' flex-shrink-0 rounded-full border-2 text-lightGreen border-lightGreen'/>
                        <div className='text-left'>
                          <h4 className='text-lg font-medium text-thickGreen font-body'>
                            {testimonials[index].name}
                          </h4>
                          <p className='text-sm text-paraGreen font-body'>
                            {testimonials[index].role}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </AnimatePresence>
                </div>

                {/* Navigation Arrows */}
                {isMobileOrTablet ? (
                  <div className='flex gap-4 mt-6'>
                    <button aria-label="left"
                      onClick={prevSlide}
                      className='bg-white shadow-lg w-12 h-12 flex  font-medium  items-center justify-center rounded-full text-thickGreen hover:bg-thickGreen hover:text-white transition'
                    >
                      <FontAwesomeIcon icon={faChevronLeft} size='lg' />
                    </button>
                    <button aria-label="right"
                      onClick={nextSlide}
                      className='bg-white shadow-lg w-12 h-12 flex  font-medium  items-center justify-center rounded-full text-thickGreen hover:bg-lightGreen transition'
                    >
                      <FontAwesomeIcon icon={faChevronRight} size='lg' />
                    </button>
                  </div>
                ) : (
                  <>
                    {/* Left Arrow */}
                    <button aria-label="left"
                      onClick={prevSlide}
                      className='absolute left-10 bg-white shadow-lg w-12 h-12 flex font-medium  items-center justify-center rounded-full text-thickGreen hover:bg-thickGreen hover:text-white transition'
                    >
                      <FontAwesomeIcon icon={faChevronLeft} size='lg' />
                    </button>
                    {/* Right Arrow */}
                    <button aria-label="right"
                      onClick={nextSlide}
                      className='absolute right-10 bg-white shadow-lg w-12 h-12 font-medium  flex items-center justify-center rounded-full text-thickGreen hover:bg-lightGreen hover:text-white transition'
                    >
                      <FontAwesomeIcon icon={faChevronRight} size='lg' />
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}